import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Input, Button, Checkbox, Modal, DatePicker,Tooltip,Divider ,Icon} from "antd";
import {
  numberFormat,
  phoneNumFormat
} from "../../util";
import {
  SearchOutlined,LockOutlined
} from '@ant-design/icons';
import string from "../../string";
import { httpGet, httpUrl, httpPost, httpDownload } from "../../api/httpClient";
import SelectBox from "../../components/common/SelectBox";
import SelectBox2 from "../../components/common/SelectBox2";


const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

class MemberRewardWater extends Component {
  constructor(props) {
    super(props);
    this.state = {
     searchText:"",
     pagination:  {
        total: 0,
        current:0,
     },
     list: [],
    };
  }

  getUserRewardlist = (params = {}) => {
    let pageNum = params.pageNum || 1;
    const { searchText } = this.state
    httpGet(httpUrl.userRewardWaterList, [10, pageNum, searchText])
    .then(res => {
      const pagination = {...this.state.pagination}
      pagination.total = res.data.totalCount;
      this.setState({
        list: res.data.userRewardWaterList,
        pagination,
      })
    })
  }  

  
 componentDidMount() {
 this.getUserRewardlist();
}
onSearch = (value) => {
    this.setState(
      {
        searchText: value,
      },
      () => {
        this.getUserRewardlist({});

      }
    );
  };


handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.getUserRewardlist({
      pageNum: pager.current,
    });
  };


  render() {
    const rewardColumns = [      
      {
        title: "아이디",
        dataIndex: "userId",
        key: "userId",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },   
      {
        title: "이름",
        dataIndex: "userName",
        key: "userName",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },   
      {
        title: "은행",
        dataIndex: "userBankCode",
        key: "userBankCode",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {string.bankString[data]}
           </div>
        ),
      },   
      {
        title: "예금주",
        dataIndex: "userAccountHolder",
        key: "userAccountHolder",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },   
      {
        title: "계좌번호",
        dataIndex: "userBankAccount",
        key: "userBankAccount",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },  
       
      {
        title: "추천인아이디",
        dataIndex: "recommenderId",
        key: "recommenderId",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },  
      {
        title: "추천인 구좌번호",
        dataIndex: "targetUserAccountSeq",
        key: "targetUserAccountSeq",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },    
             
      
     
    ];


    return (
      <div className="flex-row flex-column">
       
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          <Divider orientation="left" style={{fontSize:21.5}}>추천인 보상 </Divider>
          
        </div>
       
       

<div className="flex-row flex-center flex-end m-b-10">
  
           </div>
        <div className="flex-row flex-center m-b-10 flex-sb">
          <div className="flex-row flex-center">
           
          </div>
          
          <div className="flex-row flex-center">
          
            <label htmlFor="searchType">&nbsp;</label>     
            <Search
              placeholder={`아이디로 검색하세요.`}
              enterButton={<SearchOutlined/>}
              allowClear
              onSearch={this.onSearch}
              style={{ width: 400 }}
            />
          </div>
        </div>
        <Table
          id="reward-table"
          className="flex-1"
          rowKey={(record) => record.idx}
          columns={rewardColumns}
          dataSource={this.state.list}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        //   expandedRowRender={expandedRowRender}
          
        
        />
       
      </div>
    );
  }
}


export default MemberRewardWater;
